import { Directive, ElementRef, Input, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[gridItem]',
  host: {
    class: 'lk-grid__item',
  },
})
export class GridItemDirective {
  /**
   * Ширина блока
   *
   * @type {string}
   * @memberof GridItemDirective
   */
  @Input() width: string;
  /**
   * Выравнивание блока по центру родителя
   *
   * @type {boolean}
   * @memberof GridItemDirective
   */
  @Input() center: boolean;
  /**
   * Ширина элемента из заданых величин. Так же размеры задаются в SCSS.
   *
   * @type {number}
   * @memberof GridItemDirective
   */
  @Input() size: number;

  constructor(private _renderer: Renderer2, private _element: ElementRef) {}

  ngOnInit(): void {
    const { width, center, size } = this;

    if (width) {
      this._renderer.setStyle(this._element.nativeElement, 'width', width);
      this._renderer.setStyle(this._element.nativeElement, 'flex', 'none');
    }
    if (center) {
      this._renderer.addClass(this._element.nativeElement, 'lk-grid__item--center');
    }
    if (size) {
      this._renderer.addClass(this._element.nativeElement, 'lk-grid__item--size');
      this._renderer.addClass(this._element.nativeElement, `lk-grid__item--size_${size}`);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this._renderer.removeClass(this._element.nativeElement, `lk-grid__item--size_${changes.size.previousValue}`);
    this._renderer.addClass(this._element.nativeElement, `lk-grid__item--size_${changes.size.currentValue}`);
  }
}
